// ! Lembrar de alinhar sempre ao que tem no BACKEND
const MovementEnum = {
  ALUGUEL: 1,
  SUBSTITUICAO: 2,
  DEVOLUCAO: 3,
  RESERVA: 4,
  AVULSO: 7,
  SUBSTITUICAO_MANUTENCAO: 5,
  DEVOLUCAO_MANUTENCAO: 6,
};

export function getMovementName(value) {
  return Object.keys(MovementEnum).find((key) => MovementEnum[key] === value);
}

export default MovementEnum;
